module.exports = __webpack_public_path__ + "06b1fed195e6d4179feed621721447b4.pdf";